import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnDestroy, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AppComponent implements OnDestroy {
  title = 'app';
  isPublicRoute = true;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit(): void {
    this.updateRouteMode(this.router.url);

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe(event => {
        this.updateRouteMode(event.urlAfterRedirects);
      });

    if (isPlatformBrowser(this.platformId)) {
      const splash = this.document.getElementById('splash-screen');
      if (splash) {
        splash.style.opacity = '0';
        setTimeout(() => splash.remove(), 300); // Aguarda transição
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateRouteMode(url: string): void {
    const cleanUrl = (url || '').split('?')[0].toLowerCase();
    const isSecureRoute = /^\/(login|adm(\/|$)|treino(\/|$)|treino-)/.test(cleanUrl);

    this.isPublicRoute = !isSecureRoute;
    if (isPlatformBrowser(this.platformId)) {
      this.document.body.classList.toggle('public-route', this.isPublicRoute);
      this.document.body.classList.toggle('secure-route', isSecureRoute);
    }
  }
}
